export default {
    PtSelectLanguage: {
        language: '言语',
    },
};
